export default __webpack_public_path__ + "static/media/5148.8244e944.png";